export default __webpack_public_path__ + "static/our-history-c388aea70181b0e7fa6ad85fe9e231f7.jpg";